export const REQUEST_UTM_FORM_FILTERS = 'UTM_FORM_FILTERS';
export const REQUEST_UTM_FORM_FILTERS_SUCCEEDED = 'UTM_FORM_FILTERS_SUCCEEDED';
export const REQUEST_UTM_FORM_FILTERS_FAILED = 'UTM_FORM_FILTERS_FAILED';

export const REQUEST_UTM_FORM_CREATE_LEAD = 'UTM_FORM_CREATE_LEAD';
export const REQUEST_UTM_FORM_CREATE_LEAD_SUCCEEDED = 'UTM_FORM_CREATE_LEAD_SUCCEEDED';
export const REQUEST_UTM_FORM_CREATE_LEAD_FAILED = 'UTM_FORM_CREATE_LEAD_FAILED';
